import { gql } from 'apollo-angular';

export const GenerateUserStripeAccountLoginUrlDocument = gql`
  mutation generateUserStripeAccountLoginUrl {
    generateUserStripeAccountLoginUrl
  }
`;
